function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.046 27.108h4.59L9.18 16.478l8.375-8.817h-4.55l-9.381 9.865V.252H0v26.856h3.624v-5.395l2.939-2.98 6.482 8.375z",
  fill: "url(#text_only_svg__paint0_linear)"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.727 17.364c0 6.12 4.268 10.227 10.066 10.227 3.14 0 5.879-1.006 7.811-2.898l-1.69-2.376c-1.45 1.49-3.705 2.295-5.758 2.295-3.906 0-6.322-2.738-6.604-6.04h15.381v-.885c0-5.96-3.624-10.51-9.462-10.51-5.677 0-9.744 4.55-9.744 10.188zm9.744-7.207c4.107 0 5.838 3.221 5.919 5.798H22.512c.201-2.657 2.054-5.798 5.96-5.798z",
  fill: "url(#text_only_svg__paint1_linear)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M42.063 31.457l-.564 3.261c.564.161 1.651.282 2.255.282 2.819-.04 4.953-1.127 6.2-4.187L59.539 7.66h-3.906l-6.08 15.26-6.08-15.26h-3.865l8.012 19.649-1.127 2.577c-.604 1.45-1.49 1.892-2.818 1.892-.484 0-1.168-.12-1.61-.322z",
  fill: "url(#text_only_svg__paint2_linear)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M62.48 27.108h3.623V13.58c.846-1.45 3.302-2.819 5.114-2.819.483 0 .886.04 1.248.121V7.218c-2.577 0-4.872 1.49-6.362 3.422V7.661H62.48v19.447z",
  fill: "url(#text_only_svg__paint3_linear)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M89.21 27.108h3.624V7.661H89.21v13.971c-1.087 1.45-3.14 2.738-5.395 2.738-2.496 0-4.107-.966-4.107-4.187V7.661h-3.624v13.73c0 4.107 2.054 6.2 6.201 6.2 2.98 0 5.436-1.53 6.925-3.14v2.657z",
  fill: "url(#text_only_svg__paint4_linear)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M102.199 34.517V24.29c1.57 2.134 3.825 3.302 6.362 3.302 5.073 0 8.657-3.866 8.657-10.227 0-6.362-3.584-10.187-8.657-10.187-2.617 0-4.953 1.328-6.362 3.261V7.661h-3.623v26.856h3.623zm11.234-17.153c0 4.067-2.215 7.006-5.838 7.006-2.215 0-4.429-1.328-5.396-2.858v-8.254c.967-1.57 3.181-2.86 5.396-2.86 3.623 0 5.838 2.94 5.838 6.967z",
  fill: "url(#text_only_svg__paint5_linear)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M127.169 27.591c1.892 0 3.02-.523 3.785-1.248l-.927-2.738c-.362.403-1.127.765-1.972.765-1.249 0-1.893-1.006-1.893-2.375V10.842h3.946V7.66h-3.946V2.346h-3.624v5.315h-3.221v3.18h3.221v11.96c0 3.06 1.571 4.79 4.631 4.79z",
  fill: "url(#text_only_svg__paint6_linear)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M134.121 27.108h3.624V7.661h-3.624v19.447z",
  fill: "url(#text_only_svg__paint7_linear)"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M148.672 27.108h3.906l8.012-19.447h-3.905l-6.08 15.26-6.08-15.26h-3.865l8.012 19.447z",
  fill: "url(#text_only_svg__paint8_linear)"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M162.324 17.364c0 6.12 4.268 10.227 10.066 10.227 3.141 0 5.879-1.006 7.811-2.898l-1.691-2.376c-1.449 1.49-3.704 2.295-5.757 2.295-3.906 0-6.322-2.738-6.604-6.04h15.381v-.885c0-5.96-3.624-10.51-9.462-10.51-5.677 0-9.744 4.55-9.744 10.188zm9.744-7.207c4.107 0 5.838 3.221 5.919 5.798h-11.878c.201-2.657 2.054-5.798 5.959-5.798z",
  fill: "url(#text_only_svg__paint9_linear)"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.7,
  d: "M135.892 4.63c1.288 0 2.335-1.006 2.335-2.295S137.18 0 135.892 0c-1.248 0-2.335 1.047-2.335 2.335 0 1.289 1.087 2.295 2.335 2.295z",
  fill: "#000"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M135.894 4.634c1.288 0 2.335-1.007 2.335-2.295a2.337 2.337 0 0 0-2.335-2.335c-1.248 0-2.335 1.047-2.335 2.335s1.087 2.295 2.335 2.295z",
  fill: "url(#text_only_svg__paint10_linear)",
  opacity: 0.7
});

var _ref13 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "text_only_svg__paint0_linear",
  x1: 0,
  y1: 0.252,
  x2: 12.832,
  y2: 67.291,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.199,
  stopColor: "#E2E2E2"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), React.createElement("linearGradient", {
  id: "text_only_svg__paint1_linear",
  x1: 0,
  y1: 0.252,
  x2: 12.832,
  y2: 67.291,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.199,
  stopColor: "#E2E2E2"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), React.createElement("linearGradient", {
  id: "text_only_svg__paint2_linear",
  x1: 0,
  y1: 0.252,
  x2: 12.832,
  y2: 67.291,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.199,
  stopColor: "#E2E2E2"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), React.createElement("linearGradient", {
  id: "text_only_svg__paint3_linear",
  x1: 0,
  y1: 0.252,
  x2: 12.832,
  y2: 67.291,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.199,
  stopColor: "#E2E2E2"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), React.createElement("linearGradient", {
  id: "text_only_svg__paint4_linear",
  x1: 0,
  y1: 0.252,
  x2: 12.832,
  y2: 67.291,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.199,
  stopColor: "#E2E2E2"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), React.createElement("linearGradient", {
  id: "text_only_svg__paint5_linear",
  x1: 0,
  y1: 0.252,
  x2: 12.832,
  y2: 67.291,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.199,
  stopColor: "#E2E2E2"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), React.createElement("linearGradient", {
  id: "text_only_svg__paint6_linear",
  x1: 0,
  y1: 0.252,
  x2: 12.832,
  y2: 67.291,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.199,
  stopColor: "#E2E2E2"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), React.createElement("linearGradient", {
  id: "text_only_svg__paint7_linear",
  x1: 0,
  y1: 0.252,
  x2: 12.832,
  y2: 67.291,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.199,
  stopColor: "#E2E2E2"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), React.createElement("linearGradient", {
  id: "text_only_svg__paint8_linear",
  x1: 0,
  y1: 0.252,
  x2: 12.832,
  y2: 67.291,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.199,
  stopColor: "#E2E2E2"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), React.createElement("linearGradient", {
  id: "text_only_svg__paint9_linear",
  x1: 0,
  y1: 0.252,
  x2: 12.832,
  y2: 67.291,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.199,
  stopColor: "#E2E2E2"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), React.createElement("linearGradient", {
  id: "text_only_svg__paint10_linear",
  x1: 133.559,
  y1: 0.004,
  x2: 138.189,
  y2: 4.674,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.199,
  stopColor: "#E2E2E2"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})));

var SvgTextOnly = function SvgTextOnly(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 182 35",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

export default "data:image/svg+xml;base64,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";
export { SvgTextOnly as ReactComponent };